export default __webpack_public_path__ + "static/media/grafema_ciceco_02.e31b263b.jpg";